import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import { Colors } from '../constants/colors';
import { Font } from '../constants/fonts';

export default function Header() {
  return (
    <header style={styles.header}>
      <nav style={styles.nav}>
        <img src="/LOGO%20TM%205.svg" alt="ClickMob logo" style={styles.logo} />
        <ul style={styles.ul}>
          <li style={styles.li}>
            <Link to="/" style={styles.link}>Home</Link>
          </li>
          <li style={styles.li}>
            <Link to="/sobre" style={styles.link}>Sobre</Link>
          </li>
          <li style={styles.li}>
            <Link to="/como-funciona" style={styles.link}>Como Funciona</Link>
          </li>
           <li style={styles.li}>
            <Link to="/nossosdiferenciais" style={styles.link}>Nossos Diferenciais</Link>
          </li>
          <li style={styles.li}>
            <Link to="/quemsomos" style={styles.link}>Quem Somos</Link>
          </li>
          <li style={styles.li}>
            <Link to="/contato" style={styles.link}>Contato</Link>
          </li>
        </ul>
      </nav>
      <div style={styles.elevation} aria-hidden="true" />
    </header>
  );
}

const styles: {
  header: CSSProperties;
  nav: CSSProperties;
  ul: CSSProperties;
  li: CSSProperties;
  link: CSSProperties;
  elevation: CSSProperties;
  logo: CSSProperties;
} = {
  header: {
    backgroundColor: Colors.white,
    padding: '20px 0',
    position: 'relative',
    zIndex: 0,
    boxShadow: '0 18px 50px -22px rgba(2,6,23,0.24), 0 10px 20px -10px rgba(2,6,23,0.12)',
    transition: 'box-shadow 200ms ease',
  },
  elevation: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: -8,
    height: 28,
    pointerEvents: 'none',
    zIndex: -1,
    background: 'linear-gradient(180deg, rgba(2,6,23,0) 0%, rgba(2,6,23,0.08) 50%, rgba(2,6,23,0.18) 100%)',
    filter: 'blur(6px)',
    transform: 'translateY(6px)'
  },
  nav: {
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    flexDirection: 'row', // Linha no desktop
    alignItems: 'center',
    justifyContent: 'space-between',
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Coluna no mobile
      alignItems: 'center',
      gap: '20px',
    },
  } as any,
  ul: {
    display: 'flex',
    flexDirection: 'row', // Linha no desktop
    justifyContent: 'space-evenly',
    alignItems: 'center',
    listStyle: 'none',
    margin: 0,
    padding: 0,
    flexWrap: 'wrap',
    width: '100%',
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Coluna no mobile
      gap: '10px',
      width: '100%',
      padding: '0',
    },
  } as any,
  li: {
    margin: '0 15px',
    position: 'relative',
    '@media (max-width: 768px)': {
      margin: '5px 0',
      width: '100%',
      textAlign: 'center',
    },
  } as any,
  link: {
    color: Colors.primary,
    textDecoration: 'none',
    fontSize: Font.menu.fontSize,
    padding: '10px 15px',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    display: 'inline-block',
    letterSpacing: '0.5px',
    '&:hover': {
      backgroundColor: Colors.primary,
      color: Colors.secondaryDark,
    },
    '@media (max-width: 768px)': {
      display: 'block',
      width: '100%',
      padding: '12px 20px',
      fontSize: Font.menu.fontSize || '1.1rem',
      boxSizing: 'border-box',
    },
  } as any,
  logo: {
    height: 60,
    width: 'auto',
    display: 'block',
    '@media (max-width: 768px)': {
      height: 50,
    },
  } as any,
};